var exports = {
  "d": "xe564cbfb--5dc7d4--buttons-layout",
};

module.exports = exports;
